<template>
  <z-form ref="form" class="w-100">
    <div class="row">
      <!-- <div class="col-8"> -->
      <div class="z-form z-card border-0">
        <base-form @input="set_data" />
        <div class="row mt-4">
          <div class="col-12">
            <i-button :loading="is_loading" type="primary" size="large" @click="send">
              {{ $t('autocaller_v2.campaign.form.save_btn') }}
            </i-button>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </z-form>
</template>
<script>
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  import BaseForm from '@autocaller_v2/components/campaigns-base-form';

  export default {
    components: { BaseForm },
    data: () => ({
      is_loading: false,
      recipients: {
        recipients: [],
        include: [],
        exclude: []
      },
      form: {}
    }),
    computed: {
      get_numbers_field() {
        const db = this.recipients;
        const include = db.include.map((i) => this.format_db_fields(i));
        const exclude = db.exclude.map((i) => this.format_db_fields(i));
        const recipients = db.recipients.map((i) => i);

        return {
          include,
          exclude,
          recipients
        };
      }
    },

    methods: {
      set_data(data) {
        this.form = data;
      },
      send() {
        this.form.active_switch ? (this.form.active = 1) : (this.form.active = 0);
        this.form.record_calls_switch ? (this.form.record_calls = 1) : (this.form.record_calls = 0);
        !this.form.asr_reset
          ? (this.form.bounce_duration_threshold = 0)
          : this.form.bounce_duration_threshold;
        if (this.form.strategy[0])
          this.form.strategy = new Array(this.form.attempts_interval_min - 1).fill(1);
        this.form.strategy = this.form.strategy.map((val) => (val === null ? (val = 1) : val));
        this.form.order_rules.forEach((item, i) => (item.priority = i + 1));
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_loading = true;
            const fields = this.form;

            CampaignsService.createItem(fields)
              .then(() => {
                this.$router.push({ name: 'autocaller_v2.campaign.index' });
              })
              .catch((error) => {
                this.$noty.server_error(error);
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
      },
      format_db_fields(db) {
        const range = db.range[1] - db.range[0];
        if (range === db.recipients_count) {
          return { id: db.id };
        } else {
          return {
            id: db.id,
            range: db.range
          };
        }
      }
    }
  };
</script>
